import * as cn from 'classnames';
import { OrganizationItem } from '../organization-item';
import { Pane } from './pane';
import { useHover, useHoverDispatch } from '../../contexts/hover-context';
import { useFilter, useFilterDispatch } from '../../contexts/filter-context';
import _ from 'lodash';

export const EcosystemOverviewPane = ({
  organizations,
  ecosystemRoles,
  onRoleSelect,
  onRoleHover,
  onOrganizationSelect,
  onOrganizationHover,
  visible,
  region,
}) => {
  const dispatchFilter = useFilterDispatch();

  const { roleIds: hoveredRoleIds } = useHover();
  const dispatchHover = useHoverDispatch();

  const handleRoleHovered = (roleIds, isHovered) => {
    dispatchHover({ type: isHovered ? 'role-hovered' : 'role-unhovered', roleIds });
  };

  const isRoleHovered = (roleIds) => {
    // Returns true if ANY of roleIds are hovered
    return hoveredRoleIds.some((hri) => _.castArray(roleIds).includes(hri));
  };

  const handleRoleSelect = (roleId) => {
    dispatchFilter({ type: 'role-set', roleId });
  };

  return (
    <Pane visible={visible}>
      <div className="paneSection">
        <div className="paneTitle">Overview of Exploitation</div>
        <div className="paneDescription">
          Child sexual exploitation (CSE) is a serious form of abuse where children are coerced, manipulated, or forced into sexual activity for the benefit of
          others. It takes many forms—both online and offline—and is driven by vulnerability, demand, and systemic failures. Addressing it requires a
          coordinated, survivor-centered response.
        </div>
      </div>
      <div className="paneSection">
        <div className="paneListContainer">
          {ecosystemRoles.map((er) => (
            <div
              key={er.ID}
              className={cn('selectablePanelItem', isRoleHovered(er.ID) ? 'hover' : '')}
              onClick={() => handleRoleSelect(er.ID)}
              onMouseOver={() => handleRoleHovered(er.ID, true)}
              onMouseOut={() => handleRoleHovered(er.ID, false)}
            >
              <div className="label" style={{ pointerEvents: 'none' }}>
                {er.NAME}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Pane>
  );
};
